/* eslint-disable */
import { useEffect } from 'react';
import './style.scss';

const Home = ({ appInfo, settings, dispatch }) => {
    useEffect(() => {
        window.location.href = 'https://plugins-v2.whitewall.dev/plugins/fileuploader';
    }, []);

    return (
        <div className="ph1 ph4-m ph5-ns pb5">
            Carregando...
        </div>
    );
};

export default Home;
